import "@/App.css";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Difference from "@/components/sections/Difference";
import Credibility from "@/components/sections/Credibility";
import WhyDifferent from "@/components/sections/WhyDifferent";
import Ingredients from "@/components/sections/Ingredients";
import Product from "@/components/sections/Product";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App font-body" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Difference />
        <Credibility />
        <WhyDifferent />
        <Ingredients />
        <Product />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <Toaster theme="dark" />
    </div>
  );
}

export default App;
